import { render, staticRenderFns } from "./backgroundInfo.vue?vue&type=template&id=69e70e6a&"
import script from "./backgroundInfo.vue?vue&type=script&lang=js&"
export * from "./backgroundInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports